import { lazy, Suspense } from 'react';

function deferred(loader) {
  const View = lazy(loader);
  return function DeferredView(props) {
    return <Suspense fallback={<div role="status" style={{ padding:20, color:'var(--txt-dim)' }}>Loading view…</div>}><View {...props} /></Suspense>;
  };
}
export const OrbitalGlobe = deferred(() => import('./OrbitalGlobe.jsx'));
export const OrbitsView = deferred(() => import('./OrbitsView.jsx'));
export const TonightMap = deferred(() => import('./TonightMap.jsx'));
export const GearRecipe = deferred(() => import('./GearRecipe.jsx'));
export const PassPlot = deferred(() => import('./PassPlot.jsx'));
export const SkyPlotView = deferred(() => import('./SkyPlotView.jsx'));
